<template>
  <div>
<h2 class="goth">Modala hjälpverb</h2>
<div class="grammatikparagrafbredd leftorient">

        <p>Modala hjälpverb är verb som t.ex. <i>vill, kan, ska, måste</i> och säger något om
             omständigheterna i satsen de används i. De står oftast tillsammans med ett huvudverb i en sats
             och påverkar innebörden av detta. Huvudverbet i satsen står då i infinitiv (grundform) och hamnar sist i satsen
             (om det är en huvudsats).</p><br>


        <div class="quasi-p">Jämför denna mening utan modalt hjälpverb:

<div class="ruta">
            <div class="quasi-p leftorient">

            <div class="p-stil"><div class="dubbelrad"><i>Rebecka</i> &nbsp; <br><div class="minitext"></div></div></div>
            <div class="p-stil">&nbsp;&nbsp;<div class="dubbelrad">&nbsp;&nbsp;<i> läser</i>&nbsp;<br><div class="minitext">huvudverb</div></div></div>
            <div class="p-stil">&nbsp;&nbsp;<div class="dubbelrad">&nbsp;&nbsp;<i> snabbt</i>&nbsp;<br><div class="minitext"></div></div></div>

            </div>





            <div class="quasi-p leftorient">
            <div class="p-stil"><div class="dubbelrad"><i>Rebecka</i> &nbsp; <br><div class="minitext"></div></div></div>
            <div class="p-stil">&nbsp;&nbsp;<div class="dubbelrad">&nbsp;<i> liest</i>&nbsp;<br><div class="minitext">huvudverb</div></div></div>
            <div class="p-stil">&nbsp;&nbsp;<div class="dubbelrad">&nbsp;&nbsp;<i> schnell</i>&nbsp;<br><div class="minitext"></div></div></div>
            </div>
</div>
<br>
            med samma mening med det modala hjälpverbet <i>kan</i> tillfogat:
            <br>
        </div>
<div class="ruta">
        <div class="quasi-p leftorient">
        <div class="p-stil"><div class="dubbelrad"><i>Rebecka</i> &nbsp; <br><div class="minitext"></div></div></div>
        <div class="p-stil"><div class="dubbelrad">&nbsp;&nbsp;&nbsp;<b><i> kan</i></b>&nbsp;<br><div class="minitext">modalt hjälpverb</div></div></div>
        <div class="p-stil">&nbsp;&nbsp;<div class="dubbelrad">&nbsp;&nbsp;<i> läsa</i>&nbsp;<br><div class="minitext">huvudverb</div></div></div>
        <div class="p-stil">&nbsp;&nbsp;<div class="dubbelrad">&nbsp;&nbsp;<i> snabbt</i>&nbsp;<br><div class="minitext"></div></div></div>
        </div>

        <div class="quasi-p leftorient">
        <div class="p-stil"><div class="dubbelrad"><i>Rebecka</i> &nbsp; <br><div class="minitext"></div></div></div>
        <div class="p-stil"><div class="dubbelrad">&nbsp;&nbsp;&nbsp;<b><i> kann</i></b>&nbsp;<br><div class="minitext">modalt hjälpverb</div></div></div>
                    <div class="p-stil">&nbsp;&nbsp;<div class="dubbelrad">&nbsp;&nbsp;<i> schnell</i>&nbsp;<br><div class="minitext"></div></div></div>
        <div class="p-stil">&nbsp;&nbsp;<div class="dubbelrad">&nbsp;<i> lesen</i>&nbsp;<br><div class="minitext">huvudverb</div></div></div>
        </div>
</div>


<br>


<p> I tyskan finns hjälpverben:</p>
    <table class="bggron">
        <i>
    <tr>
    <td><b>dürfen</b></td>
    <td>få [lov att..]</td>
    </tr>

    <tr>
    <td><b>können</b></td>
    <td>kunna</td>
    </tr>

    <tr>
    <td><b>mögen</b></td>
    <td>gilla</td>
    </tr>

    <tr>
    <td><b>müssen</b></td>
    <td>måste</td>
    </tr>

    <tr>
    <td><b>sollen</b></td>
    <td>ska</td>
    </tr>

    <tr>
    <td><b>wollen</b></td>
    <td>vilja</td>
    </tr>
</i>
</table>

 <div class="quasi-p">
     De modala hjälpverben böjs annorlunda än andra verb då
<ul>
         <li>de saknar personändelser i 1:a och 3:e person singular</li>
     <li>de får en annan vokal i singular <div class="mindre inlajn">(undantaget <i>sollen</i>)</div></li>

</ul>

</div>
<br>
<p class="mindre">Ovanstående böjningsregler gäller även för verbet <i><b>wissen</b> = veta </i>.
    Så trots att det inte är ett modalt hjälpverb, tas det upp längre ner på sidan.</p>
<br>
<h4>dürfen</h4>

<div class="tableft">
<table class="">


    <tr class="leftorient">
        <td class="farg1"><i>ich</i></td>
        <td class="farg1"><i>d<div class="accented"><b>a</b></div>rf</i></td>
    </tr>

    <tr class="leftorient">

        <td class="farg1"><i>du</i></td>
        <td class="farg1"><i>d<b><div class="accented">a</div></b>rf<b>st</b></i></td>
    </tr>

    <tr class="leftorient">

        <td class="farg1"><i>er<br> es<br> sie</i></td>
        <td class="farg1"><i>d<div class="accented"><b>a</b></div>rf</i></td>
    </tr>

    <tr class="leftorient">

    </tr>


    <tr class="leftorient">
        <td class="upperspace farg1"><i>wir</i></td>
        <td class="farg1"><i>dürf<b>en</b></i></td>
    </tr>

    <tr class="leftorient">


        <td class="farg1"><i>ihr</i></td>
        <td class="farg1"><i>dürf<b>t</b></i></td>
    </tr>

    <tr class="leftorient">


        <td class="farg1"><i>sie<br> Sie</i></td>
        <td class="farg1"><i>dürf<b>en</b></i></td>
    </tr>


</table>
</div>
<br class="clear">

<p><i>dürfen</i> betyder <i>"få"</i> i meningen att man <i>får lov</i> att göra något, t.ex.
<i>"Jag får köra bil." &nbsp; "Ich darf autofahren."</i></p>
<p>Det skall inte blandas ihop med verbet som på svenska heter likadant (få) men
betyder att man ”tar emot något”, t.ex. <i>"Jag får en present."</i>. Det sistnämna heter på tyska
<i>bekommen</i> eller <i>kriegen</i>. <i>"Ich bekomme / kriege ein Geschenk."</i>
</p>

<br>

<h4>können</h4>

<div class="tableft">
<table>



    <tr class="leftorient">
        <td class="farg2"><i>ich</i></td>
        <td class="farg2"><i>k<div class="accented"><b>a</b></div>nn</i></td>
    </tr>

    <tr class="leftorient">

        <td class="farg2"><i>du</i></td>
        <td class="farg2"><i>k<div class="accented"><b>a</b></div>nn</i><b>st</b></td>
    </tr>

    <tr class="leftorient">

        <td class="farg2"><i>er<br> es<br> sie</i></td>
        <td class="farg2"><i>k<div class="accented"><b>a</b></div>nn</i></td>
    </tr>

    <tr class="leftorient">

    </tr>


    <tr class="leftorient">
        <td class="upperspace farg2"><i>wir</i></td>
        <td class="farg2"><i>könn<b>en</b></i></td>
    </tr>

    <tr class="leftorient">


        <td class="farg2"><i>ihr</i></td>
        <td class="farg2"><i>könn<b>t</b></i></td>
    </tr>

    <tr class="leftorient">


        <td class="farg2"><i>sie<br> Sie</i></td>
        <td class="farg2"><i>könn<b>en</b></i></td>
    </tr>


</table>
</div>
<br class="clear">
<p><i>können</i> betyder <i>kunna</i> (i presens <i>kan</i>) och används på samma sätt som svenska.</p>


<br>

<h4>mögen</h4>


<div class="tableft">
<table class="">


    <tr class="leftorient">
        <td class="farg3"><i>ich</i></td>
        <td class="farg3"><i>m<div class="accented"><b>a</b></div>g</i></td>
    </tr>

    <tr class="leftorient">

        <td class="farg3"><i>du</i></td>
        <td class="farg3"><i>m<b><div class="accented">a</div></b>g<b>st</b></i></td>
    </tr>

    <tr class="leftorient">

        <td class="farg3"><i>er<br> es<br> sie</i></td>
        <td class="farg3"><i>m<div class="accented"><b>a</b></div>g</i></td>
    </tr>

    <tr class="leftorient">

    </tr>


    <tr class="leftorient">
        <td class="upperspace farg3"><i>wir</i></td>
        <td class="farg3"><i>mög<b>en</b></i></td>
    </tr>

    <tr class="leftorient">


        <td class="farg3"><i>ihr</i></td>
        <td class="farg3"><i>mög<b>t</b></i></td>
    </tr>

    <tr class="leftorient">


        <td class="farg3"><i>sie<br> Sie</i></td>
        <td class="farg3"><i>mög<b>en</b></i></td>
    </tr>


</table>
</div>
<br class="clear">







<p><i>mögen</i> betyder <i>gilla</i>.</p>
<div class="ruta">
    <br><i>
    Jag gillar min katt.
    <br><br>
    Ich mag meine Katze.
    <br></i><br>
</div><br>
<p>Här gäller det dock att tänka på att <i>gilla</i> på svenska inte är ett modalt hjälpverb,
varför man måste använda ett <i>"att"</i> framför huvudverbet om sådant finns. På tyska är <i>mögen</i> ett
modalt hjälpverb och likt de andra modala hjälpverben används INGET <i>"zu"</i> framför huvudverbet.<br>
</p>

<div class="ruta">
<p>
<i>Jag gillar <b>att</b> läsa.</i>
<br><br>
<i>Ich mag lesen.</i><br>
<div class="accented">INTE</div><br>
<i><del>Ich mag zu lesen.</del></i>

</div>
<br>
<p>
Ofta används verbet <i>mögen</i> i s.k. <i>konjunktiv</i> och antar då formen <i>möchte</i> och betydelsen
<i>"skulle vilja"</i>.</p>

<div class="ruta">
<p><i>Ich möchte lieber zu Hause sein.</i> <br> <i>Jag skulle hellre vilja vara hemma.</i></p>
<p><i>Möchten Sie eine Tasse Kaffee haben?</i> <br> <i>Skulle Ni vilja ha en kopp kaffe?</i></p>
</div>

<br>
<h4>müssen</h4>

<div class="tableft">
<table class="">


    <tr class="leftorient">
        <td class="farg4"><i>ich</i></td>
        <td class="farg4"><i>m<div class="accented"><b>u</b></div>ss</i></td>
    </tr>

    <tr class="leftorient">

        <td class="farg4"><i>du</i></td>
        <td class="farg4"><i>m<b><div class="accented">u</div></b>ss<b>t</b></i></td>
    </tr>

    <tr class="leftorient">

        <td class="farg4"><i>er<br> es<br> sie</i></td>
        <td class="farg4"><i>m<div class="accented"><b>u</b></div>ss</i></td>
    </tr>

    <tr class="leftorient">

    </tr>


    <tr class="leftorient">
        <td class="upperspace farg4"><i>wir</i></td>
        <td class="farg4"><i>müss<b>en</b></i></td>
    </tr>

    <tr class="leftorient">


        <td class="farg4"><i>ihr</i></td>
        <td class="farg4"><i>müss<b>t</b></i></td>
    </tr>

    <tr class="leftorient">


        <td class="farg4"><i>sie<br> Sie</i></td>
        <td class="farg4"><i>müss<b>en</b></i></td>
    </tr>


</table>
</div>
<br class="clear">


<p><i>müssen</i> betyder <i>måste</i> och används på samma sätt som på svenska.</p>

<br>
<h4>sollen</h4>

<div class="tableft">
<table class="">


    <tr class="leftorient">
        <td class="farg5"><i>ich</i></td>
        <td class="farg5"><i>soll</i></td>
    </tr>

    <tr class="leftorient">

        <td class="farg5"><i>du</i></td>
        <td class="farg5"><i>soll<b>st</b></i></td>
    </tr>

    <tr class="leftorient">

        <td class="farg5"><i>er<br> es<br> sie</i></td>
        <td class="farg5"><i>soll</i></td>
    </tr>

    <tr class="leftorient">

    </tr>


    <tr class="leftorient">
        <td class="upperspace farg5"><i>wir</i></td>
        <td class="farg5"><i>müss<b>en</b></i></td>
    </tr>

    <tr class="leftorient">


        <td class="farg5"><i>ihr</i></td>
        <td class="farg5"><i>soll<b>t</b></i></td>
    </tr>

    <tr class="leftorient">


        <td class="farg5"><i>sie<br> Sie</i></td>
        <td class="farg5"><i>soll<b>en</b></i></td>
    </tr>


</table>
</div>
<br class="clear">


<p><i>sollen</i> är besläktat med engelskans <i>shall</i> och svenskans <i>ska</i>,
    men har inte exakt samma betydelse.</p>
    <div class="quasi-p"> <i>sollen</i> används när <div class="farg5 inlajn">
        &nbsp;någon annan vill&nbsp;</div> att handlingen skall utföras.<br>
        </div><br>
<div class="ruta">
<p><i>Man <b>ska</b> vara artig.</i>
</p><p>
<i>Man <b>soll</b> höflich sein. </i>
</p></div>
<br>


<p class="mindre">Obs! På svenska används ordet <i>ska</i> ibland enbart för att uttrycka framtid, inget krav från någon.
På tyskan används <i>werden</i> i motsvarande fall, eller inget hjälpverb alls:
</p>

<div class="ruta mindre">
    <p>
<i>Imorgon <b>ska</b> jag åka på semester. </i><br>
 <i>Morgen <b>werde</b> ich ins Urlaub fahren.</i><br>
eller bara
 <br>
     <i>Morgen fahre ich ins Urlaub.</i>
</p>
</div>
<br>
<p>Till skillnad från alla andra modala hjälpverb, byter inte <i>sollen</i> vokal i singular.</p>

<br>
<h4>wollen</h4>

<div class="tableft">
<table class="">


    <tr class="leftorient">
        <td class="farg6"><i>ich</i></td>
        <td class="farg6"><i>w<div class="accented"><b>i</b></div>ll</i></td>
    </tr>

    <tr class="leftorient">

        <td class="farg6"><i>du</i></td>
        <td class="farg6"><i>w<b><div class="accented">i</div></b>ll<b>st</b></i></td>
    </tr>

    <tr class="leftorient">

        <td class="farg6"><i>er<br> es<br> sie</i></td>
        <td class="farg6"><i>w<div class="accented"><b>i</b></div>ll</i></td>
    </tr>

    <tr class="leftorient">

    </tr>


    <tr class="leftorient">
        <td class="upperspace farg6"><i>wir</i></td>
        <td class="farg6"><i>woll<b>en</b></i></td>
    </tr>

    <tr class="leftorient">


        <td class="farg6"><i>ihr</i></td>
        <td class="farg6"><i>woll<b>t</b></i></td>
    </tr>

    <tr class="leftorient">


        <td class="farg6"><i>sie<br> Sie</i></td>
        <td class="farg6"><i>woll<b>en</b></i></td>
    </tr>


</table>
</div>
<br class="clear">

<br>
<div class="quasi-p inlajn">I de flesta fall används <i>wollen</i> som vill i svenskan.
    Det handlar om en handling som skall utföras av <div class="farg6 inlajn">&nbsp;egen vilja&nbsp;</div>. </div>


<div class="quasi-p ruta">

<i>Jag <b>vill</b> bli läkare.
<br>
Ich <b>will</b> Arzt werden. </i>

</div>

<br>
<p>
I vissa fall används <i>wollen</i> när svenskan använder <i>ska</i>.
T.ex. i frågor/uppmaningar till första person plural: <br>

<div class="quasi-p ruta">
<i><b>Ska</b> vi gå och simma? <br><b>Wollen</b> wir schwimmen gehen? </i><br>
</div>
<br>(På detta sätt är tyskan mer konsekvent än svenskan.
I meningen ovan är det ingen annan som kräver det som skall
göras utan den som utför handlingen önskar det själv. Alltså så skall <i>wollen</i> användas.)

<br>
<p class="mindre">tyskans <i>will</i> betyder INTE samma som engelskans <i>will</i>.
(detta är en vanlig missuppfattning bland svenska elever). Se nedanstående exempel:<br><br>
</p>

<div class="ruta quasi-p mindre">
<i>Ich <b>will</b> Morgen ein neues Auto kaufen.</i> (tyska) <br> <i>Jag <b>vill</b> köpa en ny bil imorgon </i>(svenska)
<br><i>I <b>want to</b> buy a new car tomorrow.</i> (engelska)

<br><br>

<i>I <b>will</b> buy a new car tomorrow.</i> (engelska)<br> <i>Jag <b>kommer att</b> köpa en ny bil imorgon.</i> (svenska)
<br><i>Ich <b>werde</b> Morgen ein neues Auto kaufen</i> (tyska) <br>
</div>



<br>



<br>

<div class="mindre">
<h4>wissen</h4>

<div class="tableft">
    <table class="">
<br>

        <tr class="leftorient">
            <td class="vit"><i>ich</i></td>
            <td class="vit"><i>w<div class="accented">ei</div>ß</i></td>
        </tr>

        <tr class="leftorient">

            <td class="vit"><i>du</i></td>
            <td class="vit"><i>w<div class="accented">ei</div>ß<b>t</b></i></td>
        </tr>

        <tr class="leftorient">

            <td class="vit"><i>er<br> es<br> sie</i></td>
            <td class="vit"><i>w<div class="accented">ei</div>ß</i></td>
        </tr>

        <tr class="leftorient">
            <td class="upperspace vit"><i>wir</i></td>
            <td class="vit"><i>wiss<b>en</b></i></td>
        </tr>

        <tr class="leftorient">


            <td class="vit"><i>ihr</i></td>
            <td class="vit"><i>wiss<b>t</b></i></td>
        </tr>

        <tr class="leftorient">


            <td class="vit"><i>sie<br> Sie</i></td>
            <td class="vit"><i>wiss<b>en</b></i></td>
        </tr>


    </table>
</div>
<br class="clear">
<p> <i>wissen</i> betyder <i>veta</i> och är egentligen inget modalt hjälpverb, men
har ett böjningsmönster som påminner om de modala hjälpverben och tas därför upp här.
</p>
<br><br><br>
</div>


</div>
</div>

</template>

<script>

export default {
  name: 'Grammatik',
  props: {
    msg: String
},
metaInfo() {
    return {
        meta: [
            {
                vmid: "description",
                name: "description",
                content: "modala hjälpverb können mögen mag müssen muss wollen will dürfen darf wieß wissen"
            }
        ]
    }
},

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

th {
    font-weight: bold;
}

.tableft {
    float: left;
}
.clear {
    clear: both;
}

.farg1 {
    background-color: #f5a142;
}

.farg2 {
    background-color: #f5f242;
}

.farg3 {
    background-color: #8df542;
}

.farg4 {
    background-color: #72fcef;
}

.farg5 {
    background-color: #c496ff;
}

.farg6 {
    background-color: #ffadf1;
}

</style>
